import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { dailyBalance } from "../../utils/dailyBalance";
import { toCurrency } from "../../utils/currency";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useTranslation } from "react-i18next";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const options = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      position: "top" as const,
    },
    title: {
      display: true,
      text: "labels.eachDateBalance",
    },
  },
};

const ReportRight = () => {
  const transactions = useSelector(
    (state: RootState) => state.app.transactions,
  );
  const { t: tCommon } = useTranslation("common");

  // console.log("ReportRight:transactions:", transactions);
  const dailySummary = dailyBalance(transactions).map((item) => {
    return {
      date: item.date,
      income: toCurrency(item.income),
      expense: toCurrency(item.expense),
      balance: toCurrency(item.balance),
    };
  });

  const dates = dailySummary.map((item) => {
    return item.date;
  });
  const expenseData = dailySummary.map((item) => {
    return item.expense.replace(/[￥,]/g, "");
  });
  const incomeData = dailySummary.map((item) => {
    return item.income.replace(/[￥,]/g, "");
  });

  const data = {
    labels: dates,
    datasets: [
      {
        label: tCommon("transaction.income"),
        data: incomeData,
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: tCommon("transaction.expense"),
        data: expenseData,
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };

  const title = tCommon(options.plugins.title.text);
  options.plugins.title.text = title;
  return <Bar options={options} data={data} style={{ padding: "2rem" }} />;
};

export default ReportRight;
